const { tns } = require('../../../node_modules/tiny-slider/src/tiny-slider');

if (document.querySelector('.js-building-card-slider')) {
    document.querySelectorAll('.js-building-card-slider').forEach((slider) => {
        tns({
            container: slider,
            slideBy: 1,
            speed: 500,
            autoplay: false,
            center: false,
            mouseDrag: true,
            nav: false,
            autoplayButtonOutput: false,
            loop: false,
            items: 3,
            responsive: {
                [window.cssBreakpoints.wide]: {
                    edgePadding: 0,
                    items: 5,
                },
            },
            controlsText: ['\uf053', '\uf054'],
            gutter: 20,
        });
    });

    const sublinks = document.querySelectorAll('.js-building-card-sublink');

    sublinks.forEach((sublink) => {
        sublink.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            let parent = sublink.dataset.parent || null;
            let child = sublink.dataset.child || null;
            parent = document.getElementById(parent);
            child = document.getElementById(child);

            if (parent && child) {
                parent.classList.add('u-hidden');
                child.classList.remove('u-hidden');

                window.addEventListener('click', (ee) => {
                    if (child !== ee.target || !child.contains(ee.target)) {
                        child.classList.add('u-hidden');
                        parent.classList.remove('u-hidden');
                    }
                });
            } else {
                window.location.href = sublink.href;
            }
        });
    });
}
